// extracted by mini-css-extract-plugin
export default {"wishlist":"WishList_wishlist__1d5xK"};